import { render, staticRenderFns } from "./COrderList.vue?vue&type=template&id=18b75f0b&scoped=true"
import script from "./COrderList.vue?vue&type=script&lang=ts"
export * from "./COrderList.vue?vue&type=script&lang=ts"
import style0 from "./COrderList.vue?vue&type=style&index=0&id=18b75f0b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18b75f0b",
  null
  
)

export default component.exports